import BasePart from './BasePart'

class Gain extends BasePart
  constructor: (audioContext, { value, destination }) ->
    super(audioContext)
    @instanceNode = @_createInstance()
    @setValue(value)
    @connect(destination)

  _createInstance: ->
    @setInterface(@audioContext.createGain())

  setInterface: (destination) ->
    @interface = destination

  getInterface: ->
    @interface

  getInstance: ->
    @instanceNode

  getValue: (value) ->
    @getInstance().gain.value

  setValue: (value) ->
    @getInstance().gain.value = value

export default Gain
